// Entry point for the Shakapacker build script

// Import stylesheets
import "../stylesheets/application.css"

// Import Turbo and Stimulus (Hotwire)
import "@hotwired/turbo-rails"
import "controllers"
import "channels"

const stylesheets = require.context('../stylesheets', true)
stylesheets.keys().forEach(stylesheets)

// Import homepage images for Webpack processing
const homepageImages = require.context('../images/homepage', true)
homepageImages.keys().forEach(homepageImages)

// Import root images for Webpack processing
const rootImages = require.context('../images', false, /\.(png|jpe?g|svg)$/i)
rootImages.keys().forEach(rootImages)
